import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';
import { INTEGRATIONS_API_URL } from '@/api/integrations';

// 3P sensors live in the integrations service. We aggregate across all floors
// in the building in a single round-trip by passing the full floor_ids list.
const BUILDING_SENSORS_3P_QUERY = gql`
  query BuildingSensors3p($floor_ids: [String!]) {
    sensors3p(floor_ids: $floor_ids) {
      id
      device_type
    }
  }
`;

export function useBuildingSensors3p(floorIds: string[]) {
  const { data } = useQuery(BUILDING_SENSORS_3P_QUERY, {
    variables: { floor_ids: floorIds },
    skip: floorIds.length === 0,
    context: { uri: INTEGRATIONS_API_URL },
  });

  const sensors3p: Array<{ id: string; device_type: string }> = useMemo(
    () => data?.sensors3p ?? [],
    [data],
  );

  return sensors3p;
}
